const statusChanges = [
  {
    label: "Enable testing",
    target: "test",
    sources: [
      "description", // Deprecated
      "idea",
      "pending", // Deprecated
      "sandbox", // Deprecated
      "javascript",
    ],
    icon: "glyphicon-triangle-right",
  },
  {
    label: "Disable testing",
    target: "javascript",
    sources: [
      "retest", // Deprecated
      "test",
    ],
    icon: "glyphicon-triangle-left",
  },
  {
    label: "Withdraw script",
    target: "withdrawn",
    sources: [
      "published",
    ],
    icon: "glyphicon-remove-circle",
  },
];

export default angular
  .module("LeftMenuCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("LeftMenuController", [
    "$scope",
    "$state",
    "$http",
    "$rootScope",
    "$translate",
    "$window",
    "$modal",
    "$location",
    "$anchorScroll",
    "Scripts",
    "Aliases",
    "CodeSystem",
    "modal",
    function (
      $scope,
      $state,
      $http,
      $rootScope,
      $translate,
      $window,
      $modal,
      $location,
      $anchorScroll,
      Scripts,
      Aliases,
      CodeSystem,
      modal,
    ) {
      // reload on cancel button press.
      $scope.reload = function () {
        $state.reload();
      };
      const lang = $rootScope.loggedUser.language;

      $scope.statusChanges = statusChanges;

      $scope.isValidStatusChange = change =>
        $scope.scriptmeta
        && $rootScope.scriptjs // All manual changes are to statuses that require JS.
        && change.sources.indexOf($scope.scriptmeta.STATUS) !== -1;

      $scope.changeStatus = status =>
        Scripts.updateScriptStatus($scope.scriptmeta.ID, status, (data) => {
          $scope.scriptmeta.STATUS = data.STATUS;
        });

      $scope.opentext = function (scriptID) {
        $window.open(
          `http://www.ebmeds.org/web/guest/scripts?id=${scriptID}&lang=${lang}`,
          "_blank",
        );
      };

      $scope.openTester = function (scriptId) {
        if ($scope.changedFields.size > 0) {
          $window.alert("The script has unsaved changes that won't affect the tester!");
        }
        $window.open(`api/scripts/${scriptId}/test`, "_blank");
      };

      $scope.addNewScript = function () {
        Scripts.addScript((data) => {
          $location.path(`/script/${data.ID}`);
        });
      };

      $scope.addNewAlias = () => {
        Aliases.addAlias((data) => {
          $location.path(`/alias/${data.id}`);
        });
      };

      $scope.deleteAlias = (id) => {
        modal.openDelete(id, "Alias").result.then(() => {
          Aliases.deleteAliasById(id, ({ status }) => {
            if (status === 200) {
              Scripts.unlinkAllScriptCodeAlias(id);
            }
            $location.path("/alias/");
          });
        });
      };

      $scope.addNewCodeSystem = () => {
        CodeSystem.addCodeSystem((data) => {
          $location.path(`/code-system/${data.id}`);
        });
      };

      $scope.deleteScript = (scriptID) => {
        modal.openDelete(scriptID, "Script").result.then(() => {
          Scripts.deleteScript(scriptID, () => {
            $location.path("");
          });
        });
      };

      $scope.saveAliasChanges = () => $rootScope.$emit("saveAliasChanges");

      $scope.saveCodeSystemChanges = () => $rootScope.$emit("saveCodeSystemChanges");

      $scope.saveUserChanges = function () {
        $rootScope.$emit("saveUserChanges");
      };

      $scope.saveScriptChanges = function () {
        $rootScope.$emit("saveScriptChanges");
      };

      $scope.deleteUser = function () {
        $rootScope.$emit("deleteUser");
      };

      $scope.sendMessage = function () {
        $rootScope.$emit("sendMessage");
      };

      $scope.addMessage = function () {
        $rootScope.$emit("addMessage");
      };

      $scope.replyMessage = function () {
        $rootScope.$emit("replyMessage");
      };

      $scope.deleteMessage = function () {
        $rootScope.$emit("deleteMessage");
      };

      $scope.addOrganization = function () {
        $rootScope.$emit("addOrganization");
      };

      $scope.saveOrganization = function () {
        $rootScope.$emit("saveOrganization");
      };

      $scope.deleteOrganization = function () {
        $rootScope.$emit("deleteOrganization");
      };

      // Navigate to the selected anchor
      $scope.navigateToAnchor = function (anchor) {
        $location.hash(anchor);
        $anchorScroll();
      };
    },
  ]);
